// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"47e823e1","633":"01d6d254"}[chunkId] + ".chunk.js";
};